import { ReceiptsListPage } from '@/features/receipts/pages/receipts-list-page'
import { receiptsListQuery } from '@/features/receipts/queries/receipts-list-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/projects/$projectId/_layout/receipts/')({
  loader: ({ params, context }) =>
    context.queryClient.ensureQueryData(receiptsListQuery(params.projectId)),
  staticData: { crumb: messages.crumbs.receipts },
  component: ReceiptsListPage,
})
